import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';

import { CheckoutForm } from './CheckoutForm';

const STRIPE_OPTIONS = { locale: 'fr' };

const StripeForm = (props) => {
  const {
    onClose, setResult, setSent, schoolName, cost, stripePromise,
  } = props;

  return (
    <Elements stripe={stripePromise} options={STRIPE_OPTIONS}>
      <CheckoutForm onClose={onClose} setResult={setResult} setSent={setSent} schoolName={schoolName} cost={cost} />
    </Elements>
  );
};

StripeForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  setResult: PropTypes.func.isRequired,
  setSent: PropTypes.func.isRequired,
  schoolName: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  stripePromise: PropTypes.object,
};

StripeForm.defaultProps = {
  stripePromise: null,
};

export { StripeForm };
